import React from 'react';
import { usePriceEditionState } from 'shared/state/configContexts';

function Notice({ tone, children }: { tone: 'brand' | 'warn' | 'danger'; children: React.ReactNode }) {
  const cls = tone === 'brand' ? 'border-brand/50 bg-brand/10 text-brand-strong'
    : tone === 'warn' ? 'border-brand-dim bg-brand-dim/20 text-ink'
    : 'border-danger/60 bg-danger/10 text-danger';
  return <div role="status" className={`flex items-center gap-3 rounded-[var(--radius-2)] border px-4 py-2 text-sm ${cls}`}>{children}</div>;
}

/** Price-edition notices (classic App.js top-of-page banners), same copy. */
export function Notices() {
  const { promptNewEdition, staleWarning, status, refresh } = usePriceEditionState();
  if (!promptNewEdition && !staleWarning && status !== 'error') return null;
  return (
    <div className="flex flex-col gap-2">
      {promptNewEdition && (
        <Notice tone="brand"><span>New prices available.</span><button type="button" className="underline" onClick={() => window.location.reload()}>Reload</button></Notice>
      )}
      {staleWarning && (
        <Notice tone="warn"><span>Prices may be out of date.</span><button type="button" className="underline" onClick={refresh}>Retry</button></Notice>
      )}
      {status === 'error' && (
        <Notice tone="danger"><span>Could not verify current prices. Prices shown may not reflect the latest published edition.</span><button type="button" className="underline" onClick={refresh}>Retry</button></Notice>
      )}
    </div>
  );
}
